import React, { Component } from "react";
import AutosizeTextarea from 'react-autosize-textarea';
import { enqueueSnackbar } from "notistack";
import addImage from './images/add.png';
import deleteImage from './images/delete.png';
import { Tooltip, Menu } from "antd";
import { FileDoneOutlined, SaveOutlined, ArrowLeftOutlined, FolderOpenOutlined } from '@ant-design/icons';
import ScrollUpButton from "react-scroll-up-button";
import StateWarning from './StateWarning';

class VoteAgendaCreate extends Component {
    state = {
        questions: [
            {
                QuestionId: 1,
                Question: '',
                Decision: '',
                SingleVotePerShareholder: false,
                Interest: false,
                Cumulative: false,
                SeatCount: 0,
                isCumulativeChecked: false,
                isSeatCountChecked: false,
                cumulativeItems: [],
                extraQuestionsCount: 0,
                extraQuestions: [],
            }
        ],
        nextQuestionId: 2,
        isButtonDisabled: true,
        alrdySaved: false,
        showScrollUp: false,
        agendaExists: false,
        isLoading: true,
    };

    async componentDidMount() {
        const { is_superuser } = this.props;
        if (!is_superuser) {
            alert("Доступ запрещен");
            window.location.href = `/#/`;
            return;
        }

        window.addEventListener('scroll', this.handleScroll, { passive: true });

        const meetingId = this.getMeetingId();
        if (meetingId) {
            await this.checkIfAgendaExists(meetingId);
        }
    }

    componentDidUpdate(prevProps) {
        const { is_staff, is_superuser } = this.props;
        if (prevProps.is_staff !== is_staff || prevProps.is_superuser !== is_superuser) {
            if (!is_staff && !is_superuser) {
                alert("Доступ запрещен");
                window.location.href = `/#/`;
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    checkIfAgendaExists = async (meetingId) => {
        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
        try {
            const response = await fetch(`${API_ADDRESS}agenda_exists/${meetingId}/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });

            if (response.status === 401) {
                alert("Время сессии истекло. Пожалуйста выполните вход.");
                document.getElementById("logoutBttn").click();
                return;
            }

            const data = await response.json();
            if (data.exists) {
                // Устанавливаем состояние, чтобы показать сообщение
                this.setState({
                    agendaExists: true,
                    isLoading: false,
                });
            } else {
                this.setState({ isLoading: false });
            }
        } catch (error) {
            this.setState({ isLoading: false });
        }
    };

    getMeetingId = () => {
        const match = window.location.href.match(/\/voteAgendaCreate\/(\d+)\//);
        return match ? parseInt(match[1], 10) : null;
    };

    handleSaveClick = () => {
        const allQuestionsValid = this.state.questions.every(q =>
            q.Question.trim() !== '' &&
            q.Decision.trim() !== '' &&
            (
                !q.isCumulativeChecked ||
                q.cumulativeItems.every(item => item.CumulativeItem.trim() !== '')
            ) &&
            (
                !q.isSeatCountChecked ||
                q.extraQuestions.every(ex => ex.ExtraQuestion.trim() !== '')
            )
        );

        if (!allQuestionsValid) {
            enqueueSnackbar('Заполните все обязательные поля', { variant: 'error' });
            return;
        }

        const meetingId = this.getMeetingId();
        if (!meetingId) {
            enqueueSnackbar('Не удалось определить ID собрания', { variant: 'error' });
            return;
        }

        if (this.state.alrdySaved) {
            enqueueSnackbar('Повторное сохранение невозможно', { variant: 'warning' });
            return;
        }

        const agendaData = this.state.questions.map(question => ({
            meeting_id: meetingId,
            question_id: question.QuestionId,
            single_vote_per_shareholder: question.SingleVotePerShareholder || false,
            interest: question.Interest || false,
            question: question.Question || '',
            decision: question.Decision || '',
            cumulative: question.isCumulativeChecked || false,
            seat_count: question.SeatCount || 0,
        }));

        // Формируем question_detail_data так же, как в voteAgendaRedact
        const questionDetailData = this.state.questions.flatMap(question => {
            // Только активные элементы
            const cumulativeItems = question.isCumulativeChecked
                ? question.cumulativeItems.map(item => ({
                    meeting_id: meetingId,
                    question_id: question.QuestionId,
                    detail_id: item.DetailId, // ← уже число! Никаких split!
                    detail_text: item.CumulativeItem || '',
                }))
                : [];

            const extraQuestions = question.isSeatCountChecked
                ? question.extraQuestions.map(item => ({
                    meeting_id: meetingId,
                    question_id: question.QuestionId,
                    detail_id: item.DetailId, // ← уже число!
                    detail_text: item.ExtraQuestion || '',
                }))
                : [];

            return [...cumulativeItems, ...extraQuestions];
        });

        console.log("Отправляемые данные:", { agendaData, questionDetailData });
        this.saveAgenda(agendaData, questionDetailData);
    };

    saveAgenda = async (agendaData, questionDetailData) => {
        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;

        try {
            const response = await fetch(`${API_ADDRESS}save_agenda/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                body: JSON.stringify({ agenda: agendaData, question_details: questionDetailData }),
            });

            if (response.status === 401) {
                alert("Время сессии истекло. Пожалуйста выполните вход.");
                document.getElementById("logoutBttn").click();
                return;
            }

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Ошибка сервера:', errorData);
                enqueueSnackbar(`Ошибка сохранения данных`, { variant: 'error' });
                return;
            }

            await response.json();
            enqueueSnackbar('Вопросы успешно сохранены', { variant: 'success' });
            this.setState({ alrdySaved: true, isButtonDisabled: true });
        } catch (error) {
            enqueueSnackbar('Произошла ошибка при сохранении данных', { variant: 'error' });
        }
    };

    handleAddQuestion = () => {
        const newQuestion = {
            QuestionId: this.state.nextQuestionId,
            Question: '',
            Decision: '',
            SingleVotePerShareholder: false,
            Interest: false,
            Cumulative: false,
            SeatCount: 0,
            isCumulativeChecked: false,
            isSeatCountChecked: false,
            cumulativeItems: [],
            extraQuestionsCount: 0,
            extraQuestions: [],
        };

        this.setState((prevState) => ({
            questions: [...prevState.questions, newQuestion],
            nextQuestionId: prevState.nextQuestionId + 1,
        }));
    };

    handleExtraQuestionsCountChange = (questionId, value) => {
        let count = parseInt(value, 10);
        if (isNaN(count) || count < 0) count = 0;

        this.setState((prevState) => ({
            questions: prevState.questions.map(q =>
                q.QuestionId === questionId ? { ...q, SeatCount: count } : q
            ),
        }));
    };

    handleExtraQuestionChange = (questionId, detailId, value) => {
        this.setState((prevState) => ({
            questions: prevState.questions.map(q =>
                q.QuestionId === questionId
                    ? {
                        ...q,
                        extraQuestions: q.extraQuestions.map(ex =>
                            ex.DetailId === detailId
                                ? { ...ex, ExtraQuestion: value }
                                : ex
                        ),
                    }
                    : q
            ),
        }));
    };

    handleCandidateCountChange = (questionId, value) => {
        let count = parseInt(value, 10);
        if (isNaN(count) || count < 0) count = 0;

        // Создаём массив с числовыми DetailId: 1, 2, 3...
        const newExtraQuestions = Array.from({ length: count }, (_, index) => ({
            Id: null,
            DetailId: index + 1, // ← ЧИСЛО, не строка!
            ExtraQuestion: '',
        }));

        this.setState((prevState) => ({
            questions: prevState.questions.map(q =>
                q.QuestionId === questionId
                    ? {
                        ...q,
                        extraQuestionsCount: count,
                        extraQuestions: newExtraQuestions,
                    }
                    : q
            ),
        }));
    };

    handleDeleteQuestion = (questionId) => {
        const { questions } = this.state;
        if (questions.length === 1) {
            enqueueSnackbar('Нельзя удалить последний вопрос', { variant: 'warning' });
            return;
        }

        const updatedQuestions = questions
            .filter(q => q.QuestionId !== questionId)
            .map((q, index) => ({ ...q, QuestionId: index + 1 }));

        this.setState((prevState) => ({
            questions: updatedQuestions,
            nextQuestionId: prevState.nextQuestionId - 1,
        }));
    };

    handleQuestionChange = (questionId, value) => {
        this.setState((prevState) => ({
            questions: prevState.questions.map(q =>
                q.QuestionId === questionId ? { ...q, Question: value } : q
            ),
        }), this.checkSaveButtonState);
    };

    handleDecisionChange = (questionId, value) => {
        this.setState((prevState) => ({
            questions: prevState.questions.map(q =>
                q.QuestionId === questionId ? { ...q, Decision: value } : q
            ),
        }), this.checkSaveButtonState);
    };

    handleSingleVoteChange = (questionId, event) => {
        const isChecked = event.target.checked;
        this.setState((prevState) => ({
            questions: prevState.questions.map(q =>
                q.QuestionId === questionId ? { ...q, SingleVotePerShareholder: isChecked } : q
            ),
        }));
    };

    handleInterestChange = (questionId, event) => {
        const isChecked = event.target.checked;
        this.setState((prevState) => ({
            questions: prevState.questions.map(q =>
                q.QuestionId === questionId ? { ...q, Interest: isChecked } : q
            ),
        }));
    };

    handleCumulativeChange = (questionId, event) => {
        const isChecked = event.target.checked;
        this.setState((prevState) => {
            const question = prevState.questions.find(q => q.QuestionId === questionId);
            if (!question) return prevState;

            let newCumulativeItems = [];
            if (isChecked) {
                const count = question.extraQuestionsCount || 0;
                newCumulativeItems = Array.from({ length: count }, (_, index) => ({
                    Id: null,
                    DetailId: index + 1, // ← ЧИСЛО, не строка!
                    CumulativeItem: '',
                }));
            }

            return {
                questions: prevState.questions.map(q =>
                    q.QuestionId === questionId
                        ? {
                            ...q,
                            Cumulative: isChecked,
                            isCumulativeChecked: isChecked,
                            isSeatCountChecked: false,
                            SeatCount: 0,
                            extraQuestionsCount: 0,
                            extraQuestions: [],
                            cumulativeItems: newCumulativeItems,
                        }
                        : q
                ),
            };
        });
    };

    handleSeatCountChange = (questionId, event) => {
        const isChecked = event.target.checked;
        this.setState((prevState) => {
            const question = prevState.questions.find(q => q.QuestionId === questionId);
            if (!question) return prevState;

            return {
                questions: prevState.questions.map(q =>
                    q.QuestionId === questionId
                        ? {
                            ...q,
                            isSeatCountChecked: isChecked,
                            isCumulativeChecked: false,
                            Cumulative: false,
                            SeatCount: isChecked ? q.SeatCount : 0,
                            extraQuestionsCount: isChecked ? q.extraQuestionsCount : 0,
                            cumulativeItems: [],
                            extraQuestions: isChecked ? q.extraQuestions : [],
                        }
                        : q
                ),
            };
        });
    };

    handleCumulativeCandidateCountChange = (questionId, value) => {
        let count = parseInt(value, 10);
        if (isNaN(count) || count < 0) count = 0;

        const newCumulativeItems = Array.from({ length: count }, (_, index) => ({
            Id: null,
            DetailId: index + 1, // ← ЧИСЛО
            CumulativeItem: '',
        }));

        this.setState((prevState) => ({
            questions: prevState.questions.map(q =>
                q.QuestionId === questionId
                    ? {
                        ...q,
                        extraQuestionsCount: count,
                        cumulativeItems: newCumulativeItems,
                    }
                    : q
            ),
        }));
    };

    handleCumulativeItemChange = (questionId, detailId, value) => {
        this.setState((prevState) => ({
            questions: prevState.questions.map(q =>
                q.QuestionId === questionId
                    ? {
                        ...q,
                        cumulativeItems: q.cumulativeItems.map(item =>
                            item.DetailId === detailId
                                ? { ...item, CumulativeItem: value }
                                : item
                        ),
                    }
                    : q
            ),
        }));
    };

    checkSaveButtonState = () => {
        const allQuestionsValid = this.state.questions.every(q =>
            q.Question.trim() !== '' &&
            q.Decision.trim() !== '' &&
            (
                !q.isCumulativeChecked ||
                q.cumulativeItems.every(item => item.CumulativeItem.trim() !== '')
            ) &&
            (
                !q.isSeatCountChecked ||
                q.extraQuestions.every(ex => ex.ExtraQuestion.trim() !== '')
            )
        );
        this.setState({ isButtonDisabled: !allQuestionsValid });
    };

    highlightRow = (questionId) => {
        setTimeout(() => {
            const row = document.getElementById(`question-${questionId}`);
            if (row) {
                row.classList.add('blink-animation');
                setTimeout(() => row.classList.remove('blink-animation'), 1000);
                row.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }, 100);
    };

    handleScroll = () => {
        if (this.scrollTimeout) clearTimeout(this.scrollTimeout);

        this.scrollTimeout = setTimeout(() => {
            const showScrollUp = window.scrollY > 130;
            this.setState({ showScrollUp });
        }, 50);
    };

    handleBackClick = () => {
        window.location.href = `/#/voteMeetings/`;
    };

    handleRedactDocs = () => {
        const meetingId = this.getMeetingId();
        if (meetingId) {
            window.location.href = `/#/voteMeetingRedactDocs/${meetingId}/`;
        } else {
            enqueueSnackbar('Не удалось определить ID собрания', { variant: 'error' });
        }
    };

    render() {
        const { questions, isButtonDisabled, showScrollUp, agendaExists } = this.state;

        if (agendaExists) {
            return (
                <>
                    <div className="agnd-layout-container">
                        <div className="agnd-header-row">
                            <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px'}}>
                                <div className="back-button-wrapper" onClick={this.handleBackClick}>
                                    <ArrowLeftOutlined
                                        style={{fontSize: '20px', cursor: 'pointer', marginTop: '4px'}}
                                    />
                                </div>
                                <h1>Создание вопросов</h1>
                            </div>
                        </div>
                    </div>
                    <StateWarning message="Вопросы для собрания уже существуют. Для редактирования перейдите в список собраний, выберите
                            нужное и через него сделайте обновление" />
                </>
            );
        }

        return (
            <>
                <div className="page-container">
                    <div className="agnd-layout-container">
                        <div className="agnd-header-row">
                            <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px'}}>
                                <ArrowLeftOutlined
                                    style={{fontSize: '20px', cursor: 'pointer', marginTop: '4px'}}
                                    onClick={this.handleBackClick}
                                />
                                <h1>Создание вопросов</h1>
                            </div>
                        </div>

                        <div className="agnd-content-wrapper">
                            <div className="agnd-sidebar-questions">
                                <Menu mode="inline" style={{
                                    border: '1px solid #ccc',
                                    borderRadius: '8px',
                                    backgroundColor: '#fff',
                                }}>
                                    <Menu.Item
                                        key="save"
                                        icon={<SaveOutlined/>}
                                        className="menu-item-color"
                                        onClick={this.handleSaveClick}
                                        disabled={this.state.alrdySaved}>
                                        Сохранить
                                    </Menu.Item>
                                </Menu>

                                <Menu mode="inline" style={{
                                    border: '1px solid #ccc',
                                    borderRadius: '8px',
                                    backgroundColor: '#fff',
                                }}>
                                    <Menu.Item
                                        key="docs"
                                        icon={<FolderOpenOutlined/>}
                                        onClick={this.handleRedactDocs}
                                    >
                                        Материалы
                                    </Menu.Item>
                                </Menu>

                                <Menu mode="inline" defaultOpenKeys={['questions-nav']} selectedKeys={[]} style={{
                                    border: '1px solid #ccc',
                                    borderRadius: '8px',
                                    backgroundColor: '#fff',
                                }}>
                                    <Menu.SubMenu key="questions-nav" title="Список вопросов"
                                                  icon={<FileDoneOutlined/>}>
                                        {questions.map((q) => (
                                            <Menu.Item
                                                key={`nav-${q.QuestionId}`}
                                                onClick={() => this.highlightRow(q.QuestionId)}
                                                selectable={false}
                                            >
                                                Вопрос №{q.QuestionId}
                                            </Menu.Item>
                                        ))}
                                    </Menu.SubMenu>
                                </Menu>
                            </div>

                            <div style={{flex: 1}}>
                                {questions.map((question, index) => (
                                    <div
                                        key={question.QuestionId}
                                        id={`question-${question.QuestionId}`}
                                        className={`grid-container3 ${index > 0 ? 'with-margin-top' : ''}`}
                                    >
                                        <div className="row">
                                            <div><b>№{index + 1}</b></div>
                                        </div>
                                        <div className="row3">
                                            <div></div>
                                        </div>

                                        <div className="row">
                                            <div>Текст вопроса</div>
                                            <div>
                                                <AutosizeTextarea
                                                    className="main-input"
                                                    value={question.Question}
                                                    onChange={(e) => {
                                                        this.handleQuestionChange(question.QuestionId, e.target.value);
                                                        this.checkSaveButtonState();
                                                    }}
                                                    style={{resize: 'none'}}
                                                    rows="1"
                                                />
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div>Текст решения вопроса</div>
                                            <div>
                                                <AutosizeTextarea
                                                    className="main-input"
                                                    value={question.Decision}
                                                    onChange={(e) => {
                                                        this.handleDecisionChange(question.QuestionId, e.target.value);
                                                        this.checkSaveButtonState();
                                                    }}
                                                    style={{resize: 'none'}}
                                                    rows="1"
                                                />
                                            </div>
                                        </div>

                                        <div className="row3">
                                            <div>Один голос на акционера</div>
                                            <div>
                                                <input type="checkbox"
                                                       style={{width: '15px', height: '15px', cursor: 'pointer'}}
                                                       checked={question.SingleVotePerShareholder}
                                                       onChange={(e) => this.handleSingleVoteChange(question.QuestionId, e)}/>
                                            </div>
                                        </div>

                                        <div className="row3">
                                            <div>Наличие заинтересованности</div>
                                            <div>
                                                <input type="checkbox"
                                                       style={{width: '15px', height: '15px', cursor: 'pointer'}}
                                                       checked={question.Interest}
                                                       onChange={(e) => this.handleInterestChange(question.QuestionId, e)}/>
                                            </div>
                                        </div>

                                        <div className="row3">
                                            <div>Кумулятивный вопрос</div>
                                            <div>
                                                <input type="checkbox"
                                                       style={{width: '15px', height: '15px', cursor: 'pointer'}}
                                                       checked={question.isCumulativeChecked}
                                                       onChange={(e) => this.handleCumulativeChange(question.QuestionId, e)}
                                                       disabled={question.isSeatCountChecked}/>
                                            </div>
                                        </div>

                                        <div className="row3">
                                            <div>Дополнительные вопросы</div>
                                            <div>
                                                <input type="checkbox"
                                                       style={{width: '15px', height: '15px', cursor: 'pointer'}}
                                                       checked={question.isSeatCountChecked}
                                                       onChange={(e) => this.handleSeatCountChange(question.QuestionId, e)}
                                                       disabled={question.isCumulativeChecked}/>
                                            </div>
                                        </div>

                                        {(question.isSeatCountChecked || question.isCumulativeChecked) && (
                                            <div className="row">
                                                <div>Количество мест:</div>
                                                <input
                                                    type="number"
                                                    className="numb-input2"
                                                    value={question.SeatCount || ''}
                                                    onChange={(e) => {
                                                        const val = e.target.value;
                                                        if (/^\d*$/.test(val) || val === '') {
                                                            this.handleExtraQuestionsCountChange(question.QuestionId, val);
                                                        }
                                                    }}
                                                />
                                                <div>Количество кандидатов:</div>
                                                <input
                                                    type="number"
                                                    className="numb-input2"
                                                    value={question.extraQuestionsCount || ''}
                                                    onChange={(e) => {
                                                        const val = e.target.value;
                                                        if (/^\d*$/.test(val) || val === '') {
                                                            if (question.isCumulativeChecked) {
                                                                this.handleCumulativeCandidateCountChange(question.QuestionId, val);
                                                            } else {
                                                                this.handleCandidateCountChange(question.QuestionId, val);
                                                            }
                                                        }
                                                    }}
                                                />
                                            </div>
                                        )}

                                        {/* Поля дополнительных вопросов */}
                                        {question.isSeatCountChecked &&
                                            question.extraQuestions.length > 0 &&
                                            question.extraQuestions.map((extraQuestion, idx) => (
                                                <div className="row" key={extraQuestion.DetailId}>
                                                    {idx === 0 ? (
                                                        <div>Имя:</div>
                                                    ) : (
                                                        <div></div>
                                                    )}
                                                    <div>
                                                        <input
                                                            type="text"
                                                            className="main-input"
                                                            value={extraQuestion.ExtraQuestion || ''}
                                                            placeholder="Ввод..."
                                                            onChange={(e) =>
                                                                this.handleExtraQuestionChange(question.QuestionId, extraQuestion.DetailId, e.target.value)
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            ))
                                        }

                                        {/* Поля кумулятивных вопросов */}
                                        {question.isCumulativeChecked && question.cumulativeItems.length > 0 && (
                                            (() => {
                                                return question.cumulativeItems.map((cumulativeItem, idx) => (
                                                    <div className="row" key={cumulativeItem.DetailId}>
                                                        {idx === 0 ? (
                                                            <div>Имя:</div>
                                                        ) : (
                                                            <div></div>
                                                        )}
                                                        <div>
                                                            <input
                                                                type="text"
                                                                className="main-input"
                                                                value={cumulativeItem.CumulativeItem || ''}
                                                                placeholder="Ввод..."
                                                                onChange={(e) => {
                                                                    this.handleCumulativeItemChange(question.QuestionId, cumulativeItem.DetailId, e.target.value);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                ));
                                            })()
                                        )}

                                        <div style={{display: 'flex', gap: '10px', justifyContent: 'left'}}>
                                            <Tooltip title="Удалить вопрос">
                                                <img
                                                    src={deleteImage}
                                                    alt="Удалить"
                                                    style={{cursor: 'pointer', width: '25px', height: '25px'}}
                                                    onClick={() => this.handleDeleteQuestion(question.QuestionId)}
                                                />
                                            </Tooltip>
                                            {index === questions.length - 1 && (
                                                <Tooltip title="Добавить вопрос">
                                                    <img
                                                        src={addImage}
                                                        alt="Добавить"
                                                        style={{cursor: 'pointer', width: '25px', height: '25px'}}
                                                        onClick={this.handleAddQuestion}
                                                    />
                                                </Tooltip>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <ScrollUpButton/>
                </div>
            </>
        );
    }
}

export default VoteAgendaCreate;